import styled from 'styled-components'
import TableButton from './TableButton'

const TableEditButton = styled(TableButton).attrs({
  type: 'pencil',
})``

export default TableEditButton
